import { useEffect, useMemo, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Badge,
  Button,
} from "../../../components";
import {
  GrupoServicoService,
  PessoaService,
  ServicoService,
  SessionService,
} from "../../../services";
import { responseErros } from "../../../utils";
import { buildFiltrosBody, filtrosIniciais } from "./monitor-ordem-servico";
import {
  MonitorOsClientesMaisCompram,
  MonitorOsEvolucao,
  MonitorOsFiltros,
  MonitorOsFluxo,
  MonitorOsKpis,
  MonitorOsListagemStatus,
  MonitorOsPrazosGargalos,
  MonitorOsProdutividade,
  MonitorOsSatisfacao,
  MonitorOsVendas,
} from "./components";

const pessoaService = new PessoaService();
const grupoServicoService = new GrupoServicoService();
const servicoService = new ServicoService();
const sessionService = new SessionService();

const MonitorOrdemServico = () => {
  const usuario = sessionService.getUsuario();
  const empresa = sessionService.getEmpresa();
  const acessosEmpresas = usuario?.acessosEmpresas || [];
  const filtrosPadrao = {
    ...filtrosIniciais,
    empresas: empresa ? [empresa] : [],
  };

  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(filtrosPadrao);
  const [filtros, setFiltros] = useState(filtrosPadrao);
  const filtrosBody = useMemo(() => buildFiltrosBody(filtros), [filtros]);
  const [listas, setListas] = useState({
    prestadores: [],
    gruposServico: [],
    tiposServico: [],
  });

  const activeCount =
    (acessosEmpresas.length > 0 ? filtros.empresas?.length || 0 : 0) +
    (filtros.prestadores?.length || 0) +
    (filtros.grupoServico ? 1 : 0) +
    (filtros.tipoServico ? 1 : 0);

  useEffect(() => {
    buscarListas();
  }, []);

  async function buscarListas() {
    const [resPrestadores, resGrupos, resServicos] = await Promise.all([
      pessoaService.getAll({ prestadorServico: true, limit: 200 }),
      grupoServicoService.getAll({ limit: 200 }),
      servicoService.getAll({ limit: 200 }),
    ]);
    if (!resPrestadores.isAxiosError) {
      setListas((prev) => ({
        ...prev,
        prestadores: resPrestadores.data?.rows || [],
      }));
    } else {
      responseErros(resPrestadores);
    }
    if (!resGrupos.isAxiosError) {
      setListas((prev) => ({
        ...prev,
        gruposServico: resGrupos.data?.rows || [],
      }));
    }
    if (!resServicos.isAxiosError) {
      setListas((prev) => ({
        ...prev,
        tiposServico: resServicos.data?.rows || [],
      }));
    }
  }

  const abrirFiltros = () => {
    setDraft(filtros);
    setOpen(true);
  };

  return (
    <Card className="minimal-layout-card">
      <CardContent className="minimal-layout-card-content rolagem">
        <Box sx={{ display: "flex", flexDirection: "column", pb: "24px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              pb: 3,
            }}
          >
            <Box>
              <Typography variant="h3" sx={{ fontWeight: 700 }}>
                Monitor de Ordem de Serviço
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Acompanhe o fluxo, prazos e desempenho das ordens de serviço
              </Typography>
            </Box>

            <Badge
              badgeContent={activeCount}
              color="primary"
              overlap="rectangular"
            >
              <Button
                variant="outlined"
                color="primary"
                onClick={abrirFiltros}
                startIcon={<i className="ph-fill ph-sliders-horizontal" />}
                sx={{ whiteSpace: "nowrap" }}
              >
                Filtros
              </Button>
            </Badge>
          </Box>

          <MonitorOsFiltros
            filtros={filtros}
            filtrosPadrao={filtrosPadrao}
            onAplicar={setFiltros}
            listas={listas}
            acessosEmpresas={acessosEmpresas}
            draft={draft}
            setDraft={setDraft}
            open={open}
            setOpen={setOpen}
          />
        </Box>

        <MonitorOsKpis filtrosBody={filtrosBody} />

        <Grid container spacing={2} alignItems="stretch" sx={{ mt: 0.5 }}>
          <Grid item xs={12} md={5}>
            <MonitorOsFluxo filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={7}>
            <MonitorOsVendas filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12}>
            <MonitorOsEvolucao filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={7}>
            <MonitorOsProdutividade filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={5}>
            <MonitorOsPrazosGargalos filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={8}>
            <MonitorOsClientesMaisCompram filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12} md={4}>
            <MonitorOsSatisfacao filtrosBody={filtrosBody} />
          </Grid>
          <Grid item xs={12}>
            <MonitorOsListagemStatus filtrosBody={filtrosBody} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MonitorOrdemServico;
